import { List, ListItem, ListItemText } from '@mui/material'
import { useMemo } from 'react'

import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Barcodes(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  const value = useMemo(() => {
    if (!extOrder.orderStep.barcodes || extOrder.orderStep.barcodes.length === 0) {
      return null
    }

    return (
      <List dense disablePadding component="div">
        {extOrder.orderStep.barcodes.map(value => (
          <ListItem sx={{ padding: 0 }} key={value}>
            <ListItemText primary={value} />
          </ListItem>
        ))}
      </List>
    )
  }, [texts, extOrder.orderStep.barcodes])

  if (!value) return null

  return (
    <preview.Field label={texts.barcodes.label}>{value ?? <preview.NullValue />}</preview.Field>
  )
}
